import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useSelector } from "react-redux";
import { footerLinks } from "../constants";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";

const FooterOwner = ({ handlerCertified, handlerPersonalise }) => {
  const userDetails = useSelector(
    (store) => store?.certificateVerification?.userInfo,
  );
  return (
    <div
      className="flex w-full flex-col items-center justify-center bg-[#0B1D2B] p-4"
      style={{
        filter: "drop-shadow(0px -4px 10px rgba(0, 0, 0, 0.2))",
      }}
    >
      <div className="flex w-full items-center justify-between">
        <div
          className={` ${
            window.innerWidth <= 360 ? "gap-2" : "gap-[20px]"
          } flex items-center justify-center `}
        >
          {footerLinks?.map((item, index) => (
            <a
              target="_blank"
              rel="noreferrer"
              href={item?.url}
              className="flex h-[40px] w-[40px] items-center  justify-center rounded-full bg-[#4285F4] text-white md:h-[54px] md:w-[54px]"
            >
              <FontAwesomeIcon
                size="lg"
                className="md:h-[24px] md:w-[24px]"
                icon={item?.icon}
              />
            </a>
          ))}
        </div>

        <div className="flex w-fit items-center gap-2 rounded-md bg-white p-[6px]">
          <img
            src="https://img.learntube.ai/public-assets/new%20Linkedin%20data/image%2011.png?updatedAt=1747309992449"
            loading="eager"
            alt=""
            width={24}
            height={24}
            className="h-6 w-6"
          />
          <p className="text-xs font-medium text-black">LearnTube.ai</p>
        </div>
      </div>
      <div className="mt-6 flex w-full flex-col items-center justify-center gap-2">
        <div
          className="w-full cursor-pointer rounded-[6px] border-[1px]  border-[#7fc241] py-[10px] text-center text-[14px]  font-medium text-[#7fc241] md:text-[16px]"
          onClick={(e) => {
            Mixpanel.track(
              Constants.Mixpanel
                .CERTIFICATE_VERIFICATION_OWNER_PAGE_GET_CERTIFIED_CLICKED,
              { distinct_id: userDetails?.email },
            );
            handlerCertified({
              utm_source: "certificate-verification",
              utm_medium: "get-certified",
            });
          }}
        >
          Get Certified
        </div>
        <div
          className="w-full cursor-pointer rounded-[6px] border-[1px] border-[#7fc241] py-[10px] text-center text-[14px]  font-medium text-[#7fc241] md:text-[16px]"
          onClick={(e) => {
            Mixpanel.track(
              Constants.Mixpanel
                .CERTIFICATE_VERIFICATION_OWNER_PAGE_BUILD_PERSONALIZED_COURSE_CLICKED,
              { distinct_id: userDetails?.email },
            );
            handlerPersonalise({
              utm_source: "certificate-verification",
              utm_medium: "build-course",
            });
          }}
        >
          Build A Course
        </div>
      </div>
      <div className="mt-4 flex w-full items-center justify-center gap-2 text-[12px] font-medium text-white md:gap-3 md:text-[20px]">
        <div
          className="cursor-pointer"
          onClick={(e) => window.open("https://learntube.ai", "_blank")}
        >
          Home
        </div>
        <div className="h-[6px] w-[6px] rounded-full bg-[#4285F4]/20" />
        <div
          className="cursor-pointer"
          onClick={(e) =>
            window.open("https://learntube.ai/about-us", "_blank")
          }
        >
          About Us
        </div>
        <div className="h-[6px] w-[6px] rounded-full bg-[#4285F4]/20" />
        <div
          className="cursor-pointer"
          onClick={(e) =>
            window.open("https://learntube.ai/contactus", "_blank")
          }
        >
          Contact Us
        </div>
      </div>
      <div className=" mt-6 flex items-center justify-center gap-1 text-[12px] font-normal text-white/70 md:text-[18px] ">
        <span className="text-[16px] text-white"> © </span> 2026 LearnTube.ai
      </div>
    </div>
  );
};

export default FooterOwner;
